<template>
  <div>
    <div
      v-if="title"
      class="mb-6 inline-block rounded-full px-3 py-1 text-base font-medium leading-tight"
      :style="{ backgroundColor: titleBg }"
    >
      {{ title }}
    </div>
    <ul
      class="flex flex-col border-t border-t-[#B8BCC3]"
      :class="{ 'mt-6': !title }"
    >
      <BenefitsListItem
        v-for="(benefit, i) in benefits"
        :key="`benefit-item-${i}`"
        :benefit="benefit"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { SbBenefits } from '~/storyblok/types/storyblok.gen'

const props = defineProps({
  slug: {
    type: String as PropType<string>,
    required: true,
  },
})

const { data: cmsData } = await useCmsStory<SbBenefits>({
  params: {
    slug: props.slug,
    baseFolder: CmsBaseFolder.Benefits,
  },
  key: `benefits-${props.slug}`,
})

const title = computed(() => cmsData.value?.content?.title ?? '')
const titleBg = computed(
  () => cmsData?.value?.content?.title_color?.color ?? '#a6ccf1',
)
const benefits = computed(() => cmsData.value?.content?.items ?? [])
</script>
